module.exports = __webpack_public_path__ + "f6ade2a48b1fae361ce2fb7780788827.png";